<template>
  <div id="app" :class="{SGD:this.$institut === 'SGD', HFB: this.$institut === 'HFB'}">
    <router-view></router-view>
  </div>
</template>

<script>

  export default {
    name: 'app',
    created () {
      // console.log("create app")
    }
  }
</script>

<style lang="scss">
  $FontPathOpenSans: "/fonts";
  /* hfb fonts */
  @import '../node_modules/typeface-fira-sans/index.css';

  /* import login-page styles */
  @import '../../wl-vue-component-login/dist/wl-vue-component-login.css';

  //@import url(http://fonts.googleapis.com/css?family=Roboto+Slab|Open+Sans|Open+Sans+Bold:400italic,700italic,400,700);
  $main-bg-color: #FFF;

  $main-font-family: Fira Sans;

  $main-font-size: 16px;

  body {
    background: $main-bg-color;
    margin: 0;
    padding: 0;
  }
  #app {
    font-family:  $main-font-family;
    font-size: $main-font-size;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
</style>
